import { render, staticRenderFns } from "./LevelBar.vue?vue&type=template&id=8b39f62a&scoped=true&"
import script from "./LevelBar.vue?vue&type=script&lang=js&"
export * from "./LevelBar.vue?vue&type=script&lang=js&"
import style0 from "./LevelBar.vue?vue&type=style&index=0&id=8b39f62a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b39f62a",
  null
  
)

export default component.exports